import { render, staticRenderFns } from "./ResubmitRenewal.vue?vue&type=template&id=5b7763bc&scoped=true"
import script from "./ResubmitRenewal.vue?vue&type=script&lang=js"
export * from "./ResubmitRenewal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7763bc",
  null
  
)

export default component.exports